import React from 'react';

const BannerNoInstalacion = () => {
  return (
    <div className="row mt-5">
      <div className="col-12">
        <div className="d-flex align-items-center p-4 bg-light rounded border-start border-primary border-4 shadow-sm">
          <div className="flex-shrink-0 me-4 text-primary">
            <i className="fas fa-exclamation-triangle display-6"></i>
          </div>
          <div className="flex-grow-1">
            <h5 className="h6 fw-bold mb-1 text-dark">
              No realizamos instalaciones
            </h5>
            <p className="mb-0 text-secondary">
              Nuestro servicio es exclusivamente de venta.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerNoInstalacion;
